export default __webpack_public_path__ + "47456d9b36d14e6f39626dfc2978b1bb.jpg";